import { CommunicationsComponent } from './communications.component';

import { CommunicationsResolver } from '../../../resolves/communications.resolver';

export const CommunicationsRoutes: Array<any> = [
  {
    path: 'communications',
    component: CommunicationsComponent,
    resolve: {
      data: CommunicationsResolver
    },
    canActivate: [],
  }
];



// WEBPACK FOOTER //
// ./src/app/components/dashboard/communications/communications.routes.ts